export default __webpack_public_path__ + "static/prueba-home-4a220b68891c008308bb5506bdca39c6.jpg";